import { create } from 'zustand';
import { User } from '@packet/management/src/DTO/user';
import { getUserDetail } from '../api/user';

interface UserPermissionModalState {
  isOpen: boolean;
  user: User | null;
  loading: boolean;
  error: string | null;
  openUserPermission: (id: number) => Promise<void>;
  closeUserPermission: () => void;
}

export const useUserPermissionModalStore = create<UserPermissionModalState>((set, get) => ({
  isOpen: false,
  user: null,
  loading: false,
  error: null,

  openUserPermission: async (id: number) => {
    set({
      isOpen: true,
      loading: true,
      error: null,
      user: null,
    });

    try {
      const response = await getUserDetail({ id });
      if (response.code === 0) {
        set({
          user: response.data,
          loading: false,
        });
      } else {
        set({
          error: response.message || '获取用户信息失败',
          loading: false,
        });
      }
    } catch (error) {
      set({
        error: error instanceof Error ? error.message : '获取用户信息失败',
        loading: false,
      });
    }
  },

  closeUserPermission: () => {
    set({
      isOpen: false,
      user: null,
      loading: false,
      error: null,
    });
  },
}));
